import { Components, Theme } from '@mui/material/styles'

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.secondary.dark,
      borderRadius: '10px',
      padding: 4,
    }),
    grouped: ({ theme }) => ({
      color: theme.palette.text.primary,
      borderColor: theme.palette.secondary.dark,
      borderRadius: '8px',
      textTransform: 'none',
    }),
  },
}
